export const getDefaultState = () => ({
  hasSurveyCompleteCondition: false,
  hasSurveyIncompleteCondition: false,
});
